import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE, MatCommonModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export function createCustomMatPaginatorIntl(translate: TranslateService) {
  return new CustomMatPaginatorIntl(translate);
}

export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.getTranslations();
    this.translate.onLangChange.subscribe(() => this.getTranslations());
  }

  getTranslations(): void {
    this.translate.get('extLibraries.matPaginator').subscribe((texts) => {
      this.nextPageLabel = texts['next'];
      this.previousPageLabel = texts['previous'];
      this.itemsPerPageLabel = texts['itemsPerPage'];
      this.changes.next();
    });
  }
}

@NgModule({
  imports: [
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatIconModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    MatRadioModule,
    MatBottomSheetModule,
    MatTabsModule,
    MatListModule,
    MatBadgeModule,
    MatDialogModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatPaginatorModule,
    MatChipsModule,
    MatCommonModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  exports: [
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatIconModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    MatRadioModule,
    MatBottomSheetModule,
    MatTabsModule,
    MatListModule,
    MatBadgeModule,
    MatDialogModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatSortModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatChipsModule,
    MatCommonModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: createCustomMatPaginatorIntl,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'fr-FR',
    },
  ],
})
export class MatImportModule {}
